<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ng-container *ngFor="let p of consulta?.lista; let i = index">
      <h2 class="subtitle">{{i+1}}º PROPRIETÁRIO</h2>
      <ul class="card-list-striped">
        <li><span class="text-secondary">Nome do proprietário</span><span>{{p?.nomeProprietario || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Documento </span><span>{{p?.doc || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">UF </span><span>{{p?.uf || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Municipio </span><span>{{p?.municipio || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Correção chassi renavam </span><span>{{p?.correcaoChassiRenavam || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Data Autorização</span><span>{{p?.dataAutorizacao | date: 'dd/MM/yyyy' || 'NÃO INFORMADO'}}</span></li>
      </ul>
    </ng-container>

  </ng-container>

</app-card-consulta>
